import { addDataLayerEvent } from "../../../../utils/data.layer.utils/data.layer.util";

const FormButton = ({ button, trackingVals, getFormData, setOpenBATD }) => {
	return (
		<a
			title={button.form.name}
			className={`waves-effect waves-light btn-large bb${button.colour}`}
			onClick={() => {
				addDataLayerEvent('BannerEventFormButton', trackingVals);
				getFormData(button.form.handle);
				setOpenBATD(true);
			}}
		>
			{button.title}
		</a>
	);
};

export default FormButton;